export default __webpack_public_path__ + "static/media/Ch4c.a92e34ba.gif";